module.exports = __webpack_public_path__ + "img/21.5844d4c0.png";